<template>
  <div class="tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl">
    <template
      v-for="(company, index) in companies"
      :key="company.id"
    >
      <div
        v-if="index > 0"
        class="tw-w-full tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
      />
      <AddAgencyCompaniesListItem
        :company="company"
        @close="$emit('close')"
        @select-company="(selectedCompany) => $emit('select-company', selectedCompany)"
      />
    </template>
  </div>
</template>

<script>
import AddAgencyCompaniesListItem from '@/components/Administration/Agency/Companies/AddAgencyCompaniesListItem.vue';
import { mapState } from 'vuex';

export default {
  name: 'AddAgencyCompaniesList',
  components: {
    AddAgencyCompaniesListItem,
  },
  computed: {
    ...mapState({
      companies: (state) => state.v2.admin.cms.agency.companies.companiesByNameOrIco,
    }),
  },
};
</script>
